import { TranslationSchema } from "../zh";

const login: TranslationSchema['login'] = {
  brand_product: 'Creator Outreach',
  brand_tagline: 'A professional TikTok creator outreach and marketing management platform',
  hero_welcome: 'Welcome to Wowbit.ai',
  hero_desc:
    'Sign in with phone or email. Official store authorization (SEA) · DMs / platform email / targeted invitations.',
  plan_pro: 'Pro',
  hero_feature:
    'Massive TikTok creator inventory, precise targeting, bulk DM invites, email outreach, and product-directed recommendations—one flow from discovery to outreach to collab management, ',
  hero_feature_highlight: 'making creator connections more precise and marketing collaborations more efficient.',

  title: 'Welcome to Wowbit.ai',
  subtitle: 'Sign in to start connecting with creators',
  register_title: 'Sign up for Wowbit.ai',
  register_subtitle: 'Fill in your details to start connecting with creators',
  wechat_login: 'Sign in with WeChat',
  wechat_qr_title: 'WeChat sign-in',
  wechat_scan: 'Scan with WeChat to sign in',
  wechat_qr_failed: 'Could not create the QR code',
  wechat_expired: 'QR code expired. Create a new one',
  wechat_refresh: 'Create again',
  wechat_expires_in: 'Expires in {{time}}',
  or: 'or',
  login_method: 'Sign-in method',
  code_login: 'Verification code',
  password_login: 'Password',

  account_label: 'Phone / Email',
  account_placeholder: 'Enter phone number or email',
  account_required: 'Please enter phone number or email',
  account_invalid: 'Please enter a valid phone number or email',
  username_label: 'Username',
  username_placeholder: 'Enter username',
  username_required: 'Please enter username',
  username_max: 'Username can be at most 12 characters',
  display_name_max: 'Display name can be at most 128 characters',
  code_label: 'Verification code',
  code_placeholder: '6-digit code',
  code_required: 'Please enter verification code',
  code_len: 'Verification code must be 6 digits',
  code_digits: 'Verification code must be 6 digits',
  send_code: 'Get code',
  password_label: 'Password',
  password_placeholder: 'Enter password',
  password_required: 'Please enter password',
  password_min: 'Password must be at least 6 characters',
  password_rule: 'Password must be at least 12 characters and no more than 72 UTF-8 bytes',
  login_password_rule: 'Password must be no more than 72 characters and 72 UTF-8 bytes',

  login_btn: 'Sign in',
  register_btn: 'Sign up',
  forgot_password: 'Forgot password?',
  go_register: 'Sign up now',
  go_login: 'Already have an account? Sign in',

  reset_password_title: 'Reset password',
  new_password_label: 'New password',
  new_password_required: 'Please enter a new password',
  confirm_password_label: 'Confirm new password',
  confirm_password_required: 'Please confirm the new password',
  password_mismatch: 'Passwords do not match',
  reset_password_rule:
    'At least 12 characters, no spaces, and no more than 72 UTF-8 bytes',
  reset_password_btn: 'Reset password',
  reset_password_success: 'Password reset. Please sign in with your new password',
  reset_password_failed: 'Reset failed',
  reset_password_failed_retry: 'Reset failed, please try again later',

  code_sent: 'Verification code sent',
  send_failed: 'Failed to send',
  send_failed_retry: 'Failed to send, please try again later',
  login_success: 'Signed in successfully',
  login_failed: 'Sign-in failed',
  login_failed_retry: 'Sign-in failed, please try again later',
  register_success: 'Registered successfully, please sign in',
  register_failed: 'Registration failed',
  register_failed_retry: 'Registration failed, please try again later'
};

export default login;
